import React from 'react';


function PrivacyPolicy() {
  return (
    <div className="services-page">
      <h2>Privacy Policy</h2>
      <p><em>Last updated: December 12, 2025</em></p>
      <h3>1. Introduction</h3>
      <p>
        Build Jamaica (“we”, “us”, or “our”) is committed to protecting your privacy. This Privacy Policy explains how we collect, use, store, and share your personal information when you use our website and services.
      </p>
      <h3>2. Information We Collect</h3>
      <p>We may collect the following personal information from you:</p>
      <ul>
        <li>Name</li>
        <li>Email address</li>
        <li>Phone number</li>
        <li>Physical address</li>
        <li>Service requests and project details</li>
        <li>Any other information you provide through our forms or communications</li>
      </ul>
      <h3>3. How We Use Your Information</h3>
      <ul>
        <li>Provide and manage our property, project management, building, and maintenance services</li>
        <li>Communicate with you about your requests or projects</li>
        <li>Connect you with contractors or service providers as needed</li>
        <li>Improve our services and website</li>
        <li>Comply with legal obligations</li>
      </ul>
      <h3>4. Sharing Your Information</h3>
      <p>
        We only share your phone number and address with third-party contractors or service providers when necessary to carry out the work you have requested. We do not sell or rent your personal information to third parties for marketing purposes.
      </p>
      <h3>5. Data Retention and Deletion</h3>
      <p>
        We retain your personal information only as long as necessary to fulfill the purposes described above or as required by law.<br />
        You have the right to request deletion of your personal information once your project or work is completed. To request deletion, please contact us at <a href="mailto:info@build-jamaica.com">info@build-jamaica.com</a>.
      </p>
      <h3>6. Limiting Data Sharing</h3>
      <p>
        You may request that we limit the sharing of your personal information with third parties. Please contact us if you wish to restrict what data is shared.
      </p>
      <h3>7. Your Rights</h3>
      <ul>
        <li>Access the personal information we hold about you</li>
        <li>Request correction of inaccurate information</li>
        <li>Request deletion of your information (subject to legal requirements)</li>
        <li>Request that we limit sharing of your data</li>
      </ul>
      <h3>8. Data Security</h3>
      <p>
        We take reasonable measures to protect your personal information from unauthorized access, disclosure, or loss.
      </p>
      <h3>9. Changes to This Policy</h3>
      <p>
        We may update this Privacy Policy from time to time. Changes will be posted on this page with an updated effective date.
      </p>
      <h3>10. Contact Us</h3>
      <p>
        If you have any questions or requests regarding your privacy, please contact us at:<br />
        <a href="mailto:info@build-jamaica.com">info@build-jamaica.com</a>
      </p>
    </div>
  );
}

export default PrivacyPolicy;
